export default __webpack_public_path__ + "static/media/Expand_right.69074634.svg";